<template>
  <div>
    <div class="container-base format-detail">
      <div class="flex align-items-center">
        <h1>{{ format.title }}</h1>
      </div>
      <div class="card detail" v-if="formatId != 'rirekisho_ai_career'">

        <div class="card-thumbnail">
          <ul class="doc-sample-images">
            <li v-for="(img, index) in format.images" :key="index"><img :src="img"
                :alt='`${format.title}テンプレート ${index}`'></li>
          </ul>
        </div>
        <div class="card-data">
          <div class="description">{{ format.description }}</div>
          <el-button class="button-block" v-if="formatId == 'shokumukeirekisho' && $site.appFlag != 'b' && false"
            type="primary" @click="openKeirekisho()" v-ripple>様々な種類の職務経歴書を見る</el-button>
          <br>
          <router-link :to="{ name: 'formatEdit', params: { formatId: format.id } }" v-ripple>
            <el-button class="button-block" type="primary" v-ripple>入力をはじめる</el-button>
          </router-link>
          <div class="text-center">
            <el-button @click="$eventHub.$emit('open-account-dialog')" type="text">
              <span v-if="$yagi.profile.autoSaveEnabled" class="autosave-status on"><i class="el-icon-circle-check"></i>
                ブラウザに自動保存: オン</span>
              <span v-else class="autosave-status off"><i class="el-icon-circle-close"></i> ブラウザに自動保存: オフ</span>
            </el-button>
          </div>
        </div>

      </div>
    </div>
    <div class="container-base r-ai-format" v-if="formatId == 'rirekisho_ai_career'">
      <div class="merit">
        <h2 class="h2">AI以外の特典もたくさん！</h2>
        <ul class="flex merit-01">
          <li class="merit-01item">
            <div class="flex merit-02">
              <p class="t-01number">01</p>
              <img src="/static/renew3_img/yagiprime_img/third01.png" alt="エージェントからの仕事紹介" class="t-01img">
            </div>
            <h3 class="h3">エージェントからの<br>仕事紹介</h3>
            <p>手厚い仕事紹介を受けることができます。</p>
          </li>
          <li class="merit-01item">
            <div class="flex merit-02">
              <p class="t-01number">02</p>
              <img src="/static/renew3_img/yagiprime_img/third02.png" alt="おすすめの求人を紹介" class="t-01img">
            </div>
            <h3 class="h3">おすすめの求人を<br>紹介</h3>
            <p>選ぶだけで簡単1クリック応募！</p>
          </li>
          <li class="merit-01item">
            <div class="flex merit-02">
              <p class="t-01number">03</p>
              <img src="/static/renew3_img/yagiprime_img/third03.png" alt="生成AIで志望動機を作成" class="t-01img">
            </div>
            <h3 class="h3">生成AIで志望動機を作成</h3>
            <p>AI志望動機機能を利用できます。</p>
          </li>
          <li class="merit-01item">
            <div class="flex merit-02">
              <p class="t-01number">04</p>
              <img src="/static/renew3_img/yagiprime_img/third04.png" alt="各種サービスが無料" class="t-01img">
            </div>
            <h3 class="h3">各種サービスが無料</h3>
            <p>ヤギのメール便とフォント変更機能が無料で使い放題です。</p>
          </li>
        </ul>
      </div>
      <router-link :to="{ name: 'formatEdit', params: { formatId: format.id } }" v-ripple>
        <el-button class="button-block" type="primary" v-ripple>入力をはじめる</el-button>
      </router-link>
    </div>
    <div class="keyword_block">
      <div class="mv">
        <h3 class="recom-h3">＼ヤギッシュのおすすめポイント／</h3>
        <ul class="renew2_flex renew2_sp_flex mv_txtblock">
          <li class="mv__txt">
            <p>提出までスムーズ<br class="sp">①郵送代行</p>
          </li>
          <li class="mv__txt">
            <p>提出までスムーズ<br class="sp">②企業宛にメール送信</p>
          </li>
          <li class="mv__txt">
            <p>会員登録で<br class="sp">バックアップ機能</p>
          </li>
          <li class="mv__txt">
            <p>無料で履歴書<br class="sp">簡単入力</p>
          </li>
          <li class="mv__txt">
            <p>履歴書の<br class="sp">フォントの変更可能</p>
          </li>
          <li class="mv__txt">
            <p>アプリでも<br class="sp">いつでも作成可能</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<sctyle scoped>
    .keyword_block .mv{
        padding: 20px 50px 40px;
        text-align: center;
    }

    .keyword_block .mv .mv_txtblock{
        justify-content: center;
        font-weight: 700;
        margin-bottom: 5px;
    }

    .keyword_block .mv .mv__txt{
        position: relative;
        font-size: 1.2rem;
        text-align: center;
        background: #fff;
        -webkit-box-shadow: 0 0 4px rgba(0,0,0,.25);
        box-shadow: 0 0 4px rgba(0,0,0,.25);
        border-radius: 50%;
        width: 150px;
        height: 150px;
        margin-left: 15px;
    }

    .keyword_block .mv .mv__txt:first-child{
        margin-left: 0;
    }

    .keyword_block .mv .mv__txt p{
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 150px;
        text-align: center;
    }

    .keyword_block .mv .mv__txt .mv__green{
        color: #0f9934;
    }

    .keyword_block .mv .mv__txt .mv__small{
        font-size: 0.8rem;
    }

    @media screen and (max-width: 640px){
        .keyword_block .mv .mv__txt{
            font-size: 1rem;
            width: 130px;
            height: 130px;
        }
        .keyword_block .mv .mv__txt p{
            width: 130px;
        }
    }

</sctyle>
<style scoped>
.keyword_block {
  text-align: center;
  width: 1100px;
  max-width: 100%;
  margin: 50px auto;
  padding: 10px;
}

.keyword_block .mv .recom-h3 {
  font-size: 1.1rem;
  margin-bottom: 10px;
}

.keyword_block .mv .mv_txtblock {
  justify-content: space-between;
  flex-wrap: wrap;
}

.keyword_block .mv .mv__txt {
  background: #EDF5E8;
  padding: 10px;
  border-radius: 10px;
  width: calc(100% / 3 - 20px);
  margin-bottom: 10px;
  color: #004D40;
  /*position: relative;
        font-size: 1.2rem;
        text-align: center;
        background: #fff;
        -webkit-box-shadow: 0 0 4px rgba(0,0,0,.25);
        box-shadow: 0 0 4px rgba(0,0,0,.25);
        border-radius: 50%;
        width: 150px;
        height: 150px;
        margin-left: 15px;*/
}

.keyword_block .mv .mv__txt p {
  /*position: absolute;
        left: 0;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        width: 150px;
        text-align: center;*/
}

@media screen and (max-width: 640px) {
  .keyword_block .mv[data-v-6def00ba] {
    padding: 40px 10px;
  }

  .keyword_block .mv .mv__txt {
    width: calc(100% / 2 - 10px);
    /*font-size: 1rem;
            width: 130px;
            height: 130px;*/
  }

  .keyword_block .mv .mv__txt p[data-v-6def00ba] {
    /*width: 130px;*/
  }
}
</style>
<style scoped>
/*メリット*/
.container-base .merit h2 {
  text-align: left;
  margin: 10px 0 5px;
}

.container-base .merit {
  margin-bottom: 10px;
}

.container-base .merit-01 {
  flex-wrap: wrap;
  justify-content: space-between;
}

.container-base .merit-02 {
  align-items: stretch;
  justify-content: center;
  margin-bottom: 10px;
}

.container-base .merit-01item {
  padding: 15px;
  border-radius: 10px;
  border: 2px dotted #0F9934;
  width: calc(100% / 2 - 5px);
  margin-bottom: 10px;
}

.container-base .t-01number {
  text-align: center;
  color: #0F9934;
  font-size: 1.2rem;
  font-weight: bold;
  opacity: 0.5;
  margin-right: 10px;
}

.container-base .t-01img {
  display: block;
  text-align: center;
  height: 50px;
  width: auto;
}
</style>
<script>
export default {
  props: {
    formatId: {
      type: String
    },
    univId: {
      type: String
    }
  },
  computed: {
    format: function (id) {
      return this.$site.getFormatById(this.formatId)
    }
  },
  methods: {
    openKeirekisho: function () {
      let link = document.createElement('a')
      link.href = 'https://bit.ly/3tXEmBS'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  beforeMount: function () {
    console.error(this.univId)
    if (this.$route.query.ap) {
      console.error("this.$route.query.ap")
      this.$cookies.config(60 * 60 * 24, '')
      this.$cookies.set('_YAGISH_ESF_AP_ID', this.$route.query.ap, null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_ESF_AP_ID', this.$route.query.ap, null, null, 'localhost')
      console.error(this.$route.query.ap)

    }
    if (this.univId) {
      this.$cookies.config(60 * 60 * 24, '')
      this.$cookies.set('_YAGISH_ATHLETE_UNIVID', this.univId, null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_ATHLETE_UNIVID', this.univId, null, null, 'localhost')
    }
    if (!this.format) {
      this.$router.replace({
        name: 'notFound'
      })
    }
  }
}
</script>
